/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 150,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    value1: "",
    value2: "",
    value3: "",
    value4: false,
    value5: false,
    value6: false,
    value7: false,
    value8: false,
    value9: false,
    value10: false,
    value11: false,
    value12: false,
    value13: false,
    value14: false,
    value15: "",
  },
];

export default function CorporateIncomeTaxTable20B({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const handleAdd = () => {
    const newRow = {
      id: uuidV4(),
      value1: "",
      value2: "",
      value3: "",
      value4: false,
      value5: false,
      value6: false,
      value7: false,
      value8: false,
      value9: false,
      value10: false,
      value11: false,
      value12: false,
      value13: false,
      value14: false,
      value15: "",
    };

    setData((prev) => [...prev, newRow]);
  };

  const handleDelete = (id) => {
    setData((prev) => prev.filter((item) => item.id !== id));
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex">
        <Typography variant="h5">
          MỤC II. DANH MỤC CÁC CÔNG TY CON CỦA TẬP ĐOÀN THEO QUỐC GIA CƯ TRÚ
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Quốc gia
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Các công ty là đối tượng cư trú ở nước sở tại
              </Td>
              <Td rowSpan={2} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Quốc gia hoặc lãnh thổ đăng ký kinh doanh nếu khác với quốc gia hoặc lãnh thổ cư trú
                thuế
              </Td>
              <Td rowSpan={1} colSpan={13} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Các hoạt động kinh doanh
              </Td>
            </tr>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Nghiên cứu và phát triển
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Nắm giữ hoặc quản lý tài sản trí tuệ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Mua hàng
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Chế tạo hoặc sản xuất
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Bán hàng, tiếp thị hoặc phân phối
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Điều hành, quản lý và các dịch vụ hỗ trợ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Cung cấp dịch vụ cho các bên không liên quan
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Tài chính nội bộ
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Các dịch vụ tài chính theo quy định
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Bảo hiểm
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Nắm giữ cổ phần hoặc các công cụ vốn khác
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Khác
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                  className="toggle-button"
                >
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value1", value: e.target.value })
                    }
                  >
                    <option value="value1">Việt Nam</option>
                    <option value="value2">Mỹ</option>
                  </select>
                  <div className="button-action delete" style={{ left: "-45px" }}>
                    <button type="button" onClick={() => handleDelete(item.id)}>
                      Xoá dòng
                    </button>
                  </div>
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                  }}
                >
                  <InputTable
                    type="text"
                    id={item.id}
                    value={item.value2}
                    name="value2"
                    onChange={handleChange}
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <select
                    style={selectStyle}
                    onChange={(e) =>
                      handleChange({ id: item.id, name: "value3", value: e.target.value })
                    }
                  >
                    <option value="value1">Việt Nam</option>
                    <option value="value2">Mỹ</option>
                  </select>
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value4}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value4" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value5}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value5" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value6}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value6" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value7}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value7" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value8}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value8" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value9}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value9" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value10}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value10" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value11}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value11" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value12}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value12" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value13}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value13" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <Switch
                    checked={item.value14}
                    onChange={({ target: { checked } }) =>
                      handleChange({ id: item.id, value: checked, name: "value14" })
                    }
                  />
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <InputTable
                    type="text"
                    id={item.id}
                    name="value15"
                    value={item.value15}
                    onChange={handleChange}
                  />
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
        <SoftButton sx={{ mt: 1 }} variant="gradient" color="dark" onClick={handleAdd}>
          Thêm dòng
        </SoftButton>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    if (!type) {
      const newValue = value === "0" ? "" : value;
      if (!regexNumber.test(newValue)) return;
      onChange({ value: newValue !== "" ? +newValue : "", name, id });
    } else {
      onChange({ value, name, id });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: !type ? "right" : "left",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
